import React from 'react';
import Error from './error_message';
import Input from './input';
import Button from './button';
import setValue from '../../helpers/set_value';

interface AutopaymentsIntegrapayFormProps {
  errors: any;
  paymentSystemAccount: any;
  save: () => void;
  setForm: (form: any) => void;
}

const AutopaymentsIntegrapayForm = ({
  errors,
  paymentSystemAccount,
  save,
  setForm,
}: AutopaymentsIntegrapayFormProps) => {
  return (
    <div>
      <div className="clearfix payment-provider">
        <div className="payment-provider-logo">
          <img alt="Worldpay" src="/worldpay.svg" />
        </div>
        <p className="first-one">
          Worldpay is a payment provider that enables businesses to accept recurring and one-off
          payments from bank accounts or credit/debit cards via Direct Debit.
        </p>
      </div>
      <br />
      <div className="form-group row">
        <label className="col-sm-3">Username</label>
        <div className="col-sm-6">
          <Input
            value={paymentSystemAccount.account_id}
            onChange={(value) => {
              setForm(setValue(paymentSystemAccount, 'account_id', value));
            }}
          />
          <Error error={errors['payment_system_account.response']} />
          <Error error={errors['payment_system_account.account_id']} />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-3">Password</label>
        <div className="col-sm-6">
          <Input
            value={paymentSystemAccount.secret_key}
            onChange={(value) => {
              setForm(setValue(paymentSystemAccount, 'secret_key', value));
            }}
          />
          <Error error={errors['payment_system_account.secret_key']} />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-sm-3"></div>
        <div className="col-sm-6 ">
          <Button
            variant="success"
            onClick={save}
            disabled={!paymentSystemAccount.account_id || !paymentSystemAccount.secret_key}
          >
            Connect
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AutopaymentsIntegrapayForm;
